"use strict";

var agendorAPI = require("app/util/api/agendor-api");

var GET_ACTIVITIES_API_VERSION = "2.2";

module.exports.list = function get(params, success, error) {
  var callbacks = {
    success: success,
    error: error
  };

  return agendorAPI.get("/activities", params, callbacks, GET_ACTIVITIES_API_VERSION);
};

module.exports.post = function post(activity, cb) {
  return agendorAPI.post("/activities", activity, cb);
};

module.exports.put = function put(activity, cb) {
  var url = "/activities/"+activity.id;
  return agendorAPI.put(url, activity, cb);
};



// WEBPACK FOOTER //
// ./app/util/api/activity.js